import React from 'react';
import { createBrowserRouter, RouterProvider,useNavigate,Navigate } from 'react-router-dom';
import { rootRoute } from './config';
import Forecasting     from './components/fc/App';
import InventoryMgmt   from './components/im/App';
import ProjectMgmt   from './components/pm/App';
import QualityMgmt   from './components/qm/App';
import SupplyChainMgmt   from './components/scm/App';
import ComingSoon from './components/ComingSoon';

import fcChildRoutes from './components/fc/Routes';
import imChildRoutes from './components/im/Routes';
import pmChildRoutes from './components/pm/Routes';
import qmChildRoutes from './components/qm/Routes';
import scmChildRoutes from './components/scm/Routes';


import NotFound404 from './components/common/NotFound404';
let pathname = window.location.pathname.toLocaleLowerCase();
/** react routes */
const routes = createBrowserRouter([
  {
    path: `${rootRoute}`,
    element: <h3>Simulation List</h3>
  },
  {
    path: `${rootRoute}/fc`,
    element: (pathname.indexOf("/fc") !== -1) ? <Forecasting /> : <ComingSoon />,
    children:(pathname.indexOf("/fc") !== -1) ? fcChildRoutes : []
  },
  {
    path: `${rootRoute}/im`,
    element: (pathname.indexOf("/im") !== -1) ? <InventoryMgmt /> : <ComingSoon />,
    children:(pathname.indexOf("/im") !== -1) ? imChildRoutes : []
  },
  {
    path: `${rootRoute}/pm`,
    element: (pathname.indexOf("/pm") !== -1) ? <ProjectMgmt /> : <ComingSoon />,
    children:(pathname.indexOf("/pm") !== -1) ? pmChildRoutes : []
  },
  {
    path: `${rootRoute}/qm`,
    element: (pathname.indexOf("/qm") !== -1) ? <QualityMgmt /> : <ComingSoon />,
    children:(pathname.indexOf("/qm") !== -1) ? qmChildRoutes : []
  },
  {
    path: `${rootRoute}/scm`,
    element: (pathname.indexOf("/scm") !== -1) ? <SupplyChainMgmt /> : <ComingSoon />,
    children:(pathname.indexOf("/scm") !== -1) ? scmChildRoutes : []
  },
  {
    path: `${rootRoute}/comingsoon`,
    element: <ComingSoon msgText='Feature Unavailable' content='Additional Settings feature is not available for this simulation' />
  },
  {
    path: '*',
    element: <ComingSoon />
  }
]);

const Routes = () => {
  return (
    <div className="row">
       <RouterProvider router={routes} />
    </div>
  );
};

export default Routes;
